/**
 * Gravitee.io Portal Rest API
 * API dedicated to the devportal part of Gravitee
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: contact@graviteesource.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Plan { 
    /**
     * Unique identifier of a plan.
     */
    id: string;
    /**
     * Name of the plan.
     */
    name: string;
    /**
     * Security used with this plan.
     */
    security: Plan.SecurityEnum;
    /**
     * Description of the plan.
     */
    description: string;
    /**
     * List of additionnal terms to describe the plan.
     */
    characteristics?: Array<string>;
    /**
     * Type of validation for subscription requests.
     */
    validation: Plan.ValidationEnum;
    /**
     * Priority order
     */
    order: number;
    /**
     * True if at least one application linked to the current user has subscribed to this plan.
     */
    subscribed?: boolean;
    /**
     * True if a comment is required when a subscription is created.
     */
    comment_required: boolean;
    /**
     * Content of the message sent to a user creating a subscription.
     */
    comment_question?: string;
}
export namespace Plan {
    export type SecurityEnum = 'API_KEY' | 'KEY_LESS' | 'JWT' | 'OAUTH2';
    export const SecurityEnum = {
        APIKEY: 'API_KEY' as SecurityEnum,
        KEYLESS: 'KEY_LESS' as SecurityEnum,
        JWT: 'JWT' as SecurityEnum,
        OAUTH2: 'OAUTH2' as SecurityEnum
    };
    export type ValidationEnum = 'AUTO' | 'MANUAL';
    export const ValidationEnum = {
        AUTO: 'AUTO' as ValidationEnum,
        MANUAL: 'MANUAL' as ValidationEnum
    };
}


